import{mergeConfigs as r}from"./mergeConfigs";export var addConfig=function(n){return function(o){return r(o,n)}};